// extracted by mini-css-extract-plugin
export default {"grayContainer":"Layout_grayContainer__Szowm","loginSignUpForm":"Layout_loginSignUpForm__a5mE6"};